import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Briefcase icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Briefcase } from '@sravni/design-system-icons'
 *
 * <Briefcase />
 * ```
 */
var Briefcase = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Briefcase", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.833 17.083H4.167c-.921 0-1.667-.745-1.667-1.666v-7.5c0-.921.746-1.667 1.667-1.667h11.666c.921 0 1.667.746 1.667 1.667v7.5c0 .92-.746 1.666-1.667 1.666Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M13.478 6.251V4.585c0-.921-.745-1.667-1.666-1.667H8.188c-.92 0-1.666.746-1.666 1.667V6.25M2.5 7.918l5.293 3.493c.272.18.591.275.918.275h2.578c.327 0 .646-.095.918-.275L17.5 7.918", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Briefcase };
//# sourceMappingURL=Briefcase.js.map
